import { apiGuestClient } from "./apiGuestClient";

export const crmSurveyFormQuestionApi = {
    selectAll: () => apiGuestClient.get(`crm_survey_form_question`),
    select_datasource: (id: number, dm_coso_id: number, fieldValue: number) => apiGuestClient.get(`crm_survey_form_question/datasource/${id}/coso/${dm_coso_id}/fieldValue/${fieldValue}`),
}